import Image from "next/image";
import { useRouter } from "next/navigation";
import { useTranslation } from "react-i18next";
import veeHexagon from "@/assets/images/icons/veeHexagon.svg";
import CustomButton from "@/common/customElements/button";
import { HorizontalCenterDiv } from "@/common/divs";
import { AlmostBoldText, LightText, RegularText } from "@/common/texts";
import { PRIMARY_BUTTON_COLOR } from "@/utils/constants";

const NoAvailableActivities: React.FC = () => {
  const { t } = useTranslation();
  const router = useRouter();
  return (
    <HorizontalCenterDiv
      width="100%"
      style={{
        gap: "10px",
        marginTop: "16px",
        flexDirection: "column",
        padding: "0 20% 0% 20%",
        height: "50vh",
        textAlign: "center",
      }}
    >
      <Image src={veeHexagon.src} alt="vee hexagon" width={108} height={108} />
      <AlmostBoldText fontSize="24px">
        {t("activity_overview.no_activities")}
      </AlmostBoldText>
      <LightText fontSize="16px">
        {t("activity_overview.no_activity_description")}
      </LightText>
      <CustomButton
        width="332px"
        height="50px"
        onClick={() => {
          router.push("/home");
        }}
        backgroundColor={PRIMARY_BUTTON_COLOR}
      >
        <RegularText> {t("reservations.no_reservations_button")}</RegularText>
      </CustomButton>
    </HorizontalCenterDiv>
  );
};

export default NoAvailableActivities;
